import { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
// import { fetchOurTeam } from "../features/PublicAPIsService";

import "./css/OurTeamSection.css";
import Slider from "react-slick";

export default function OurTeam() {
    const dispatch = useDispatch();
    // const publicState = useSelector((state) => state?.PublicAPIsService);
const team =
[
    {
        "id": "d6d8d786-c764-4474-916c-8b9f9af81bf9",
        "name": "Tanmay Jain [USA]",
        "description": "",
        "designation": "Co-Founder & Member",
        "image": "/images/profileMen.webp"
    },
    {
        "id": "e7f58b7a-0e70-4a4e-8e79-6346b5c5e4ba",
        "name": "Ruhaan Jain [USA]",
        "description": "",
        "designation": "Co-Founder & Member",
        "image": "/images/profileMen.webp"
    },
    {
        "id": "14950e9b-e2c0-4b86-b6e8-7e9bd7849cb1",
        "name": "Tanisha Jain [USA]",
        "description": "",
        "designation": "Co-Founder & Member",
        "image": "/images/Gemini_Generated_Image_jm0r5yjm0r5yjm0r.webp"
    },
    {
        "id": "f25f3f48-eea3-4e36-ae3c-9629df53ed33",
        "name": "Dr. Manish Rajput [Jaipur]",
        "description": "",
        "designation": "Member",
        "image": "/images/profileMen.webp"
    },
    {
        "id": "0e9bff7c-8f88-4443-a5c5-8fecbdff9caf",
        "name": "Ashish ji Dhamtari",
        "description": "",
        "designation": "Member",
        "image": "/images/profileMen.webp"
    },
    {
        "id": "a17067fd-4fcd-48ee-88d2-bb657c72b5ec",
        "name": "Sheetal [Raipur]",
        "description": "",
        "designation": "Member",
        "image": "/images/profileMen.webp"
    },
    {
        "id": "ba212c3c-c844-4410-84d2-05cceed0d925",
        "name": "CA Nehaa Samyak Luniya",
        "description": "",
        "designation": "Member",
        "image": "/images/Gemini_Generated_Image_jm0r5yjm0r5yjm0r.webp"
    },
    {
        "id": "981d9d3c-44d9-4db3-acc5-aceed88a3f02",
        "name": " Ravindra Jain",
        "description": "",
        "designation": "Member",
        "image": "/images/profileMen.webp"
    },
    {
        "id": "b777e972-4d3d-4189-b75e-737aeec7edb0",
        "name": "Anuja Golechha",
        "description": "",
        "designation": "Member",
        "image": "/images/Gemini_Generated_Image_jm0r5yjm0r5yjm0r.webp"
    },
    {
        "id": "78ab3afc-16a6-4a32-83eb-c18d6b76773c",
        "name": "Rajendra Pansari",
        "description": "",
        "designation": "Member",
        "image": "/images/profileMen.webp"
    },
    {
        "id": "c03cd1be-707d-475d-89b4-c22ec2011b66",
        "name": "Manju Moosal",
        "description": "",
        "designation": "Member",
        "image": "/images/Gemini_Generated_Image_jm0r5yjm0r5yjm0r.webp"
    },
    {
        "id": "956f1bd6-b7ab-4e56-b736-e80986bf98f8",
        "name": "CA Anjali Jain",
        "description": "",
        "designation": "Founding Member",
        "image": "/images/Gemini_Generated_Image_jm0r5yjm0r5yjm0r.webp"
    }
]


    const settings = {
        dots: false,
        arrows: false,
        infinite: team.length > 4, 
        autoplay: team.length > 1, 
        autoplaySpeed: 3000,
        speed: 800,
        slidesToShow: 4,
        slidesToScroll: 1,
        centerMode: true,
        centerPadding: "0px",
        responsive: [
            {
                breakpoint: 1200,
                settings: { slidesToShow: 3 },
            },
            {
                breakpoint: 980,
                settings: { slidesToShow: 2 },
            },
            {
                breakpoint: 760,
                settings: { slidesToShow: 1 },
            },
        ],
    };
    return (
        <section className="ourTeam-section">
            <div className="customcontainer">
                <div className="ourTeam-header">
                    <h2 className="ourTeam-title" data-aos="fade-up">
The Stewards of Our Vision
                    </h2>
                    <p className="ourTeam-subtitle" data-aos="fade-up">
Translating Inspiration into Action
                    </p>
                </div>

                <Slider {...settings} className="ourTeam-slider" data-aos="fade-up">
                    {team.map((member, index) => {
                        if (!member) return null;

                        const id = member?.id ?? `team-${index}`;
                        const name = member?.name ?? "";
                        const description = member?.description ?? "";
                        const image = member?.image ?? "";
                        const designation = member?.designation ?? ''
                        if (!name && !image) return null;

                        return (
                            <div
                                key={id}
                                className={`ourTeam-slide ${index % 2 === 0 ? "slide-up" : "slide-down"
                                    }`}
                            >
                                <div className="ourTeam-card">
                                    {image && (
                                        <img
                                            src={image}
                                            alt={name || "Team member"}
                                            className="ourTeam-img"
                                            loading="lazy"
                                        />
                                    )}

                                    <div className="ourTeam-info">
                                        {name && (
                                            <h4 className="ourTeam-name">{name}</h4>
                                        )}

                                        <p className="ourTeam-role">
                                            {description || ""}
                                            {description && designation ? " " : ""}
                                            {designation ? `[${designation}]` : ""}
                                        </p>

                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </Slider>
            </div>
        </section>
    );
}
